'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var preloaderBackgroundColor = function preloaderBackgroundColor(base) {
  return (0, _color2.default)(base.colorPaletteGrey[100]).fade(0.4).string();
};

exports.default = {
  circle: {
    strokeSize: 10,
    circleSize: 100,
    labelCenteredPadding: _reactackleCore.baseModule,

    labelSpacing: {
      top: _reactackleCore.baseModule,
      bottom: _reactackleCore.baseModule
    },

    valueLabel: {
      fontSize: _reactackleCore.fontSizeBody,
      fontWeight: _reactackleCore.fontWeightSemibold,
      lineHeight: 1.5
    },

    supplementText: {
      fontSize: _reactackleCore.fontSizeSmall,
      fontWeight: _reactackleCore.fontWeightNormal,
      lineHeight: 1.25
    },

    bgLine: {
      colourDefault: _reactackleCore.colorPaletteGrey200
    },

    mainLine: {
      color: _reactackleCore.colorMain,
      startColor: { h: 45, s: 94, v: 100 },
      endColor: { h: 121, s: 56, v: 69 }
    },

    secondaryLine: {
      color: null,
      opacity: 0.15
    },

    animation: {
      svg: {
        transitionDuration: 1000
      },
      circle: {
        transitionDuration: 2000
      }
    }
  },

  linear: {
    thickness: 4,

    labelSpacing: {
      top: _reactackleCore.baseModule,
      bottom: _reactackleCore.baseModule
    },

    valueLabel: {
      fontSize: _reactackleCore.fontSizeBody,
      fontWeight: _reactackleCore.fontWeightSemibold,
      lineHeight: 1.5
    },

    supplementText: {
      fontSize: _reactackleCore.fontSizeSmall,
      fontWeight: _reactackleCore.fontWeightNormal,
      lineHeight: 1.25
    },

    background: {
      colourDefault: _reactackleCore.colorPaletteGrey200
    },

    mainLine: {
      color: _reactackleCore.colorMain,
      startColor: { h: 45, s: 94, v: 100 },
      endColor: { h: 121, s: 56, v: 69 }
    },

    secondaryLine: {
      color: null,
      opacity: 0.15
    }
  },

  preloader: {
    backgroundColor: preloaderBackgroundColor,
    loaderMaxWidth: 300,
    width: '100%',
    height: 100
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-progress/dist/styles/theme.js
// module id = 774
// module chunks = 0